module.exports = __webpack_public_path__ + "static/media/Furfrou_gaussian2.fc0d638d.png";